/**
 * E-Commerce Service API
 * This is the ecommerce-service API generated by springdocs - a library for OpenAPI 3 with spring boot.
 *
 * The version of the OpenAPI document: 1.6.13
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PurchaseOrderNotFoundExceptionCauseStackTraceInner { 
    classLoaderName?: string;
    moduleName?: string;
    moduleVersion?: string;
    methodName?: string;
    fileName?: string;
    lineNumber?: number;
    nativeMethod?: boolean;
    className?: string;
}

